import _, { filter } from 'lodash'

import { HeaderShim } from '../../fuselage/global/header/header'

import { PageHeader } from '../../fuselage/blocks/page-header/page-header'
import { SpeakerCard } from '../../fuselage/components/speaker-card/speaker-card'
import { SpeakerGrid } from '../../fuselage/layout/speaker-grid/speaker-grid'




function Speakers({ speakers }) {

	const filteredSpeakers = []
	speakers.map( speaker => {
		if ( speaker.type === "Moderator" || speaker.type === "Speaker" ) filteredSpeakers.push(speaker)
	})

	// sort speakers by lastName
	let orderedSpeakers = _.orderBy( filteredSpeakers, [ speaker => speaker.lastName.toLowerCase()], ['asc'])
	// console.log('ordered:', orderedSpeakers)

	// customise order (VIP speakers to top of list)
	let customOrderedSpeakers = _.sortBy(orderedSpeakers, [
		(speaker => speaker.lastName === 'Heinecke' && speaker.firstName === "William" ? 0 : 1),
		(speaker => speaker.lastName === 'Meyer' && speaker.firstName === "Dr. Ivan" ? 0 : 1),
		(speaker => speaker.lastName === 'Green' && speaker.firstName === "David" ? 0 : 1),
		(speaker => speaker.lastName === 'Nubi' && speaker.firstName === "Pelumi" ? 0 : 1),
		(speaker => speaker.lastName === 'Granet' && speaker.firstName === "Olivier" ? 0 : 1),
		
		(speaker => speaker.lastName === 'Hutchinson' && speaker.firstName === "Guy" ? 0 : 1),
		(speaker => speaker.lastName === 'Osei Baffour' && speaker.firstName === "Magdaline" ? 0 : 1),
		(speaker => speaker.lastName === 'du Plessis' && speaker.firstName === "Dr Morné" ? 0 : 1),
		(speaker => speaker.lastName === 'Getachew Belete' && speaker.firstName === "Tadiwos" ? 0 : 1),
		(speaker => speaker.lastName === 'Tshivhengwa' && speaker.firstName === "Tshifhiwa" ? 0 : 1),
	] )
	// console.log('customOrderedSpeakers:', customOrderedSpeakers)

	// console.log('contentBlocks:', contentBlocks)
	// console.log('speakers found:', speakers.length)
	// console.log('speaker data:', speakers)


	return (
		<div style={{ width: `100%`, overflow: `hidden` }}>

			<HeaderShim />

			<PageHeader theme={'bg-primary'}>
				<div className="formatted">
					<h1>2025 Speakers</h1>
					<p>Our speakers are chosen for their industry knowledge and insight. If you would like to be considered as a speaker for FHS Africa 2025 please contact <a href="mailto:mala.patel@thebench.com" target="_blank" rel="noreferrer noopener">mala.patel@thebench.com</a></p>
				</div>
			</PageHeader>

			<section className={`block bg-default`}>
				<div className='container'>

					<SpeakerGrid decal="gap-sm">
						{
							customOrderedSpeakers?.map( speaker => {
								return (
									<SpeakerCard
										key={speaker.id}
										url={`/speakers/${speaker.id}`}
										photoUrl={speaker.photoUrl}
										fullName={`${speaker.firstName} ${speaker.lastName}`}
										jobTitle={speaker.jobTitle}
										company={speaker.organization}
									/>
								)
							})
						}
					</SpeakerGrid>
					
				</div>
			</section>

		</div>
	)
}


export async function getStaticProps() {

	const swapcardData = await fetch(
		"https://developer.swapcard.com/event-admin/graphql",
		{
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"Authorization": process.env.SWAPCARD_AUTH_KEY
			},
			body: JSON.stringify({
				query: `
					query eventPerson($eventId: ID!, $cursor: CursorPaginationInput, $filters: [EventPersonFilter!] ) {
						eventPerson(eventId: $eventId, cursor: $cursor, filters:$filters ) {
						nodes {
							id
							type
							firstName
							lastName
							jobTitle
							organization
							photoUrl
							groups {
								id
								name
							}
							withEvent(eventId: $eventId) {
							fields {
								... on SelectField {
									translations {
										value
										language
									}
									definition {
										id
										translations {
											name
											language
										}
											}
										}
									}
									badges {
										... on BadgeBarcode {
											__typename
											barcode
											createdAt
										}
									}
								}
							}
						}
					}
				`,
				variables: {
					"eventId": process.env.SWAPCARD_EVENT_ID_2025,
					"cursor": {
						"first": 200
					},
					"filters": {
						"shouldBeInGroups": "RXZlbnRHcm91cF81OTg3MDU="
					}
				}
			})
		}
	)
	
	const speakerData =  await swapcardData.json()



	return {
		props: { 
			speakers: speakerData.data.eventPerson.nodes
		}
	}
}

export default Speakers


